module.exports = __webpack_public_path__ + "static/7-39f1e7ecefb8c74e67138b58d1443f47.jpg";